import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// Pre-rendered pages carry data-prerender="<path>". Hydrate only when it matches the
// current URL; otherwise (unknown URL, or a page that was not pre-rendered) render normally.
const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
if (container.hasChildNodes() && container.dataset.prerender === currentPath) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
